import { Button, Card, Col, message, Popover, Row, Tooltip, Typography } from 'antd';
import { NextPage } from 'next';
import React, { useEffect, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import styles from '../styles/Color.module.scss'
import { Palette } from '../../@types/color';
import { Download, Platte, SunOne } from '@icon-park/react';
import { SketchPicker } from 'react-color';
import Values from 'values.js'
import { http } from '../../utils/api';
import { getColorName } from '../../constants/api';
import domtoimage from 'dom-to-image';
import { title } from '../../constants/heads';
const { Text } = Typography;
type Props = {
    item: Palette
};

const Index: NextPage<Props> = ({ item }) => {
    let ref: any = ""
    const [palette, setPalette] = useState(item.palette);
    const [tags, setTags] = useState(item.tags);
    const [isDownload, setIsDownload] = useState(false);
    const [toneList, setToneList] = useState(() => item.palette.map(v => tone(v)))

    const colorChange = (color: { hex: React.SetStateAction<string>; }, index: number) => {
        palette[index] = color.hex
        setPalette(palette.slice())
    }

    const colorChangeComplete = async (color: { hex: React.SetStateAction<string>; }, index: number) => {
        const res: any = await http(getColorName, { hex: color.hex })
        tags[index] = res.data.name
        setTags(tags.slice())
        setToneList(
            () => (
                palette.map(v => tone(v))
            )
        )
    }

    function rgbToHex(rgb: any[]) {
        return (
            "#" + rgb
                .map(x => {
                    const hex = x.toString(16);
                    return hex.length === 1 ? "0" + hex : hex;
                })
                .join("")
        );
    }

    function tone(hex: string) {
        const color = new Values(hex)
        return color.all(20).map((v: { rgb: any[]; }) => {
            return rgbToHex(v.rgb)
        })
    }

    const toneClick = (hex: string, index: number) => {
        palette[index] = hex
        setPalette(palette.slice())
    }

    const toPng = () => {
        setIsDownload(true)
        domtoimage.toPng(ref)
            .then((dataUrl) => {
                var link = document.createElement('a');
                link.download = `在线生成调色板_${title}.png`;
                link.href = dataUrl;
                link.click();
                setIsDownload(false)
            })
            .catch((error) => {
                console.error('oops, something went wrong!', error);
            });
    }

    useEffect(() => {
        setPalette(item.palette)
        setTags(item.tags)
        setToneList(() => item.palette.map(v => tone(v)))
    }, [item.palette]);

    return (
        <div ref={(e) => ref = e}>
            <Card
                hoverable
                cover={<img src={item.img} />}
                className={styles.palette}
            >
                <Row justify="space-around" style={{ textAlign: 'center', lineHeight: '38px' }}>

                    {palette.map((v, index) => (
                        <Col key={index} xs={24} sm={24} md={{ span: 6, offset: 2,pull:1}} lg={{ span: 4, offset: 0,pull:0}} xl={4} xxl={4}>
                            <div className="hex" key={index} style={{ backgroundColor: v,paddingTop:isDownload?'42.5px':'30.5px'}}>
                                <CopyToClipboard text={v}
                                    onCopy={(e) => { message.success('复制成功') }}>
                                    <Tooltip placement="top" title={`复制 ${v}`}>
                                        <p>
                                            {v}
                                        </p>
                                    </Tooltip>
                                </CopyToClipboard>
                                {!isDownload && <p>
                                    <Popover overlayInnerStyle={{ width: '600px' }} placement="bottom" title={null} content={
                                        <div style={{ display: 'flex' }}>
                                            {toneList[index].map((item: any, k: any) => (
                                                <div key={k} onClick={() => toneClick(item, index)} style={{ textAlign: 'center', lineHeight: '50px', cursor: 'pointer', backgroundColor: item, flex: '1 0 auto' }}>
                                                    {item == v && <SunOne theme="outline" size="20" fill="rgba(255, 255, 255, .8)" strokeWidth={3} />}
                                                </div>
                                            ))}
                                        </div>
                                    } trigger="click">
                                        <Tooltip placement="top" title={`色调`}>
                                            <SunOne theme="outline" size="20" fill="rgba(255, 255, 255, .8)" strokeWidth={3} />
                                        </Tooltip>
                                    </Popover>
                                    &nbsp;
                                    &nbsp;
                                    <Popover overlayClassName="color-choice" placement="bottom" title={null} content={<SketchPicker onChangeComplete={(e) => { colorChangeComplete(e, index) }} color={v} onChange={(e) => { colorChange(e, index) }} />} trigger="click">
                                        <Tooltip placement="top" title={`选择颜色`}>
                                            <Platte theme="outline" size="20" fill="rgba(255, 255, 255, .8)" strokeWidth={3} />
                                        </Tooltip>
                                    </Popover>

                                </p>}
                            </div>
                            {tags[index]}
                        </Col>
                    ))}
                </Row>
                <div style={{ textAlign: isDownload ? 'center' : 'right' }}>
                    {isDownload ? <Text style={{ paddingBottom: 0 }} type="secondary">调色板由{title}在线生成</Text> : <Tooltip placement="top" title={`下载调色板`}><Button onClick={toPng} icon={<Download theme="outline" size="16" fill="#333" strokeWidth={3} />} /></Tooltip>}
                </div>
            </Card>
        </div>
    )

}

export default Index